import React from 'react';
import { PropTypes } from 'prop-types';
import {
  Card,
  Col,
  Row,
  Divider,
} from 'antd';

const SettlementMetrics = ({
  currencyStats,
  loading,
}) => (
  <>
    <Row>
      <Col xl={8} lg={8} md={8} sm={12} xs={24}>
        <Card loading={loading}>
          <Card.Meta
            avatar={<span style={{ fontSize: '18px' }}>🇺🇸</span>}
            title="USD Profits"
            description={(
              <>
                <Divider />
                <div className="gx-actchart gx-pb-5">
                  <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
                    $
                    {new Intl.NumberFormat().format(
                      currencyStats?.USD?.processing_profit || 0,
                    )}
                  </h2>
                  <p className="gx-mb-0">From Processing</p>
                </div>
                <div className="gx-actchart gx-pb-5">
                  <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
                    $
                    {new Intl.NumberFormat().format(
                      currencyStats?.USD?.overall_usdt_profit || 0,
                    )}
                  </h2>
                  <p className="gx-mb-0">From USDT</p>
                </div>
                <div className="gx-actchart gx-pb-4">
                  <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-white">
                    {' .'}
                  </h2>
                  <p className="gx-mb-0 gx-text-white">{' .'}</p>
                </div>
              </>
                )}
          />
        </Card>
      </Col>
      <Col xl={8} lg={8} md={8} sm={12} xs={24}>
        <Card loading={loading}>
          <Card.Meta
            avatar={<span style={{ fontSize: '18px' }}>🇪🇺</span>}
            title="USD Profits"
            description={(
              <>
                <Divider />
                <div className="gx-actchart gx-pb-5">
                  <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
                    €
                    {new Intl.NumberFormat().format(
                      currencyStats?.EUR?.processing_profit || 0,
                    )}
                  </h2>
                  <p className="gx-mb-0">From Processing</p>
                </div>
                <div className="gx-actchart gx-pb-5">
                  <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
                    $
                    {new Intl.NumberFormat().format(
                      currencyStats?.EUR?.overall_usdt_profit || 0,
                    )}
                  </h2>
                  <p className="gx-mb-0">From USDT</p>
                </div>
                <div className="gx-actchart gx-pb-4">
                  <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
                    $
                    {new Intl.NumberFormat().format(
                      currencyStats?.EUR?.overall_usd_profit || 0,
                    )}
                  </h2>
                  <p className="gx-mb-0">From EUR/USD conversion</p>
                </div>
              </>
                )}
          />
        </Card>
      </Col>
      <Col xl={8} lg={8} md={8} sm={12} xs={24}>
        <Card loading={loading} title="Overall Profit">
          <div className="gx-actchart gx-pb-5">
            <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
              $
              {new Intl.NumberFormat().format(
                (currencyStats?.EUR?.overall_usd_profit || 0)
                    + (currencyStats?.EUR?.overall_usdt_profit || 0)
                    + (currencyStats?.USD?.overall_usd_profit || 0)
                    + (currencyStats?.USD?.overall_usdt_profit || 0)
                    + (currencyStats?.USD?.processing_profit || 0),
              )}
            </h2>
            <p className="gx-mb-0">Total USD+USDT</p>
          </div>
          <div className="gx-actchart gx-pb-5">
            <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
              €
              {new Intl.NumberFormat().format(
                currencyStats?.EUR?.processing_profit || 0,
              )}
            </h2>
            <p className="gx-mb-0">Total EUR</p>
          </div>
          <div className="gx-actchart gx-pb-5">
            <h2 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-white">
              {' .'}
            </h2>
            <p className="gx-mb-0 gx-text-white">{' .'}</p>
          </div>
        </Card>
      </Col>
    </Row>

    <Row>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <Card loading={loading} title="Rolling Reserve">
          <h2>HELD</h2>
          <div className="gx-actchart gx-pb-5">
            <Row>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  $
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.rolling_reserve_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">USD</p>
              </Col>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  €
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.rolling_reserve_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">EUR</p>
              </Col>
            </Row>
          </div>

          <h2>SETTLED</h2>
          <div className="gx-actchart gx-pb-5">
            <Row>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  $
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.rolling_reserve_settled || 0),
                  )}
                </h5>
                <p className="gx-mb-0">USD</p>
              </Col>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  €
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.rolling_reserve_settled || 0),
                  )}
                </h5>
                <p className="gx-mb-0">EUR</p>
              </Col>
            </Row>
          </div>

          <Divider />
          <h2>BALANCE</h2>
          <div className="gx-actchart gx-pb-5">
            <Row>
              <Col span={12}>
                <h5 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
                  $
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.rolling_reserve_amount || 0)
                    - (currencyStats?.USD?.rolling_reserve_settled || 0),
                  )}
                </h5>
                <p className="gx-mb-0">USD</p>
              </Col>
              <Col span={12}>
                <h5 className="gx-fs-xxl gx-font-weight-medium gx-mb-1 gx-text-black">
                  €
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.rolling_reserve_amount || 0)
                    - (currencyStats?.EUR?.rolling_reserve_settled || 0),
                  )}
                </h5>
                <p className="gx-mb-0">EUR</p>
              </Col>
            </Row>
          </div>
          <br />
          <br />
          <br />
        </Card>
      </Col>
      <Col xl={12} lg={12} md={12} sm={24} xs={24}>
        <Card loading={loading} title="Total">
          <h2 className="gx-text-success">SUCCESS</h2>
          <div className="gx-actchart gx-pb-5">
            <Row>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  $
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.successful_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  USD (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.successful_count || 0),
                  )}
                  )

                </p>
              </Col>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  €
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.successful_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  EUR (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.successful_count || 0),
                  )}
                  )

                </p>
              </Col>
            </Row>
          </div>

          <h2 className="gx-text-danger">FAILURE</h2>
          <div className="gx-actchart gx-pb-5">
            <Row>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  $
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.failed_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  USD (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.failed_count || 0),
                  )}
                  )

                </p>
              </Col>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  €
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.failed_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  EUR (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.failed_count || 0),
                  )}
                  )

                </p>
              </Col>
            </Row>
          </div>

          <h2 className="gx-text-warning">REFUNDS</h2>
          <div className="gx-actchart gx-pb-5">
            <Row>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  $
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.refunds_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  USD (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.refunds_count || 0),
                  )}
                  )

                </p>
              </Col>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  €
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.refunds_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  EUR (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.refunds_count || 0),
                  )}
                  )

                </p>
              </Col>
            </Row>
          </div>

          <h2 className="gx-text-pink">CHARGEBACKS</h2>
          <div className="gx-actchart gx-pb-5">
            <Row>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  $
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.chargebacks_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  USD (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.USD?.chargebacks_count || 0),
                  )}
                  )

                </p>
              </Col>
              <Col span={12}>
                <h5 className="gx-fs-xl gx-font-weight-small gx-mb-1 gx-text-grey">
                  €
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.chargebacks_amount || 0),
                  )}
                </h5>
                <p className="gx-mb-0">
                  EUR (
                  {new Intl.NumberFormat().format(
                    (currencyStats?.EUR?.chargebacks_count || 0),
                  )}
                  )
                </p>
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
  </>
);

SettlementMetrics.propTypes = {
  currencyStats: PropTypes.oneOfType([
    PropTypes.any,
  ]),
  loading: PropTypes.bool,
};

SettlementMetrics.defaultProps = {
  currencyStats: null,
  loading: false,
};

export default SettlementMetrics;
